class ExuvianceQuiz {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 6;
    this.responses = {};
    this.results = [];
    this.selectedProducts = [];

    this.init();
  }

  init() {
    // Load products data
    this.loadProductsData();

    // Setup event listeners
    this.setupEventListeners();

    // Update regimen step with product counts (NO LONGER USED)
    // this.updateRegimenStepCounts();

    // Initialize first step
    this.updateProgress();
    this.updateNavigation();
    this.updateStepClass();
  }

  loadProductsData() {
    try {
      const dataScript = document.getElementById('quiz-products-data');
      if (dataScript) {
        const data = JSON.parse(dataScript.textContent);
        this.results = data.results || [];
        this.cartUrl = data.cartUrl;
        this.cartAddUrl = data.cartAddUrl;
        this.customerId = data.customerId;
        this.customerEmail = data.customerEmail;
        this.discountCode = data.discountCode;
        this.discountPercentage = data.discountPercentage;
      }
    } catch (error) {
      console.error('Error loading products data:', error);
      this.results = [];
    }
  }

  setupEventListeners() {

    // Back button
    const backBtn = document.getElementById('quiz-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', () => this.goToPreviousStep());
    }

    // Exit button
    const exitBtn = document.getElementById('quiz-exit-btn');
    if (exitBtn) {
      exitBtn.addEventListener('click', () => this.handleExit());
    }

    // Next button
    const nextBtn = document.getElementById('quiz-next-btn');
    if (nextBtn) {
      nextBtn.addEventListener('click', () => this.goToNextStep());
    }

    // Input changes for validation
    this.setupInputListeners();

    // Email capture buttons
    this.setupEmailCaptureListeners();

    this.restartQuiz();

    // Restart button
    const restartBtn = document.getElementById('quiz-restart-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', () => this.restartQuiz());
    }
  }

  setupInputListeners() {
    // Radio buttons and checkboxes
    const inputs = document.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.saveResponse(input);
        this.validateCurrentStep();

        // Auto-advance for radio buttons on steps 1-4 (not email step)
        if (input.type === 'radio' && this.currentStep >= 1 && this.currentStep <= 4) {
          // Small delay to allow visual feedback before advancing
          setTimeout(() => {
            this.goToNextStep();
          }, 300);
        }
      });
    });
  }

  setupEmailCaptureListeners() {
    const submitEmailBtn = document.getElementById('quiz-submit-email');
    const skipEmailBtn = document.getElementById('quiz-skip-email');

    if (submitEmailBtn) {
      submitEmailBtn.addEventListener('click', () => this.handleEmailSubmit());
    }

    if (skipEmailBtn) {
      skipEmailBtn.addEventListener('click', () => this.skipEmailCapture());
    }
  }

  saveResponse(input) {
    const step = input.getAttribute('data-step');
    const name = input.name;

    if (input.type === 'checkbox') {
      // Handle multiple selections
      if (!this.responses[name]) {
        this.responses[name] = [];
      }

      if (input.checked) {
        if (!this.responses[name].includes(input.value)) {
          this.responses[name].push(input.value);
        }
      } else {
        this.responses[name] = this.responses[name].filter((v) => v !== input.value);
      }
    } else {
      // Radio button - single selection
      this.responses[name] = input.value;
    }
  }

  validateCurrentStep() {
    const currentStepEl = document.querySelector(`#step-${this.currentStep}`);
    if (!currentStepEl) return false;

    const nextBtn = document.getElementById('quiz-next-btn');
    let isValid = false;

    switch (this.currentStep) {
      case 1:
        // Check if skin type is selected
        isValid = !!this.responses['skin-type'];
        break;

      case 2:
        // Check if at least one skincare goal is selected
        isValid = this.responses['skincare-goals'] && this.responses['skincare-goals'].length > 0;
        break;

      case 3:
        // Check if age group is selected
        isValid = !!this.responses['age-group'];
        break;

      case 4:
        // Check if regimen preference is selected
        isValid = !!this.responses['regimen-preference'];
        break;

      case 5:
        // Email step - always valid (can skip)
        isValid = true;
        break;

      default:
        isValid = true;
    }

    return isValid;
  }

  goToNextStep() {
    if (!this.validateCurrentStep()) {
      return;
    }

    // Hide current step
    const currentStepEl = document.querySelector(`#step-${this.currentStep}`);
    if (currentStepEl) {
      currentStepEl.classList.remove('active');
    }

    // Move to next step
    this.currentStep++;

    // Show next step
    const nextStepEl = document.querySelector(`#step-${this.currentStep}`);
    if (nextStepEl) {
      nextStepEl.classList.add('active');

      if (nextStepEl.classList.contains('before-last-step')) {
        const formEmbed = document.querySelector('div #app-embed');
        let skinTypeInput = document.querySelector('.quiz-option input[name="skin-type"]:checked');
        let skinTypeText = skinTypeInput.nextElementSibling?.textContent || skinTypeInput.parentElement.querySelector('.quiz-option-text')?.textContent;
        formEmbed.shadowRoot.querySelector('#custom\\#skin-type').value = skinTypeText;

        let skincareGoalsInput = document.querySelector('.quiz-option input[name="skincare-goals"]:checked');
        let skincareGoalsText = skincareGoalsInput.nextElementSibling?.textContent || skincareGoalsInput.parentElement.querySelector('.quiz-option-text')?.textContent;
        formEmbed.shadowRoot.querySelector('#custom\\#skincare-goals').value = skincareGoalsText;

        let ageGroupInput = document.querySelector('.quiz-option input[name="age-group"]:checked');
        let ageGroupText = ageGroupInput.nextElementSibling?.textContent || ageGroupInput.parentElement.querySelector('.quiz-option-text')?.textContent;
        formEmbed.shadowRoot.querySelector('#custom\\#age-group').value = ageGroupText;

        let skincareRegimenInput = document.querySelector('.quiz-option input[name="regimen-preference"]:checked');
        let skincareRegimenValue = skincareRegimenInput.value
        formEmbed.shadowRoot.querySelector('#custom\\#skincare-regimen').value = skincareRegimenValue
      }
    }

    // Update UI
    this.updateProgress();
    this.updateNavigation();
    this.validateCurrentStep();
    this.updateStepClass();


    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goToPreviousStep() {
    if (this.currentStep <= 1) return;

    // Hide current step
    const currentStepEl = document.querySelector(`#step-${this.currentStep}`) || document.querySelector("#step-results");
    if (currentStepEl) {
      currentStepEl.classList.remove('active');
    }

    // Move to previous step
    this.currentStep--;

    // Show previous step
    const prevStepEl = document.querySelector(`#step-${this.currentStep}`);
    if (prevStepEl) {
      prevStepEl.classList.add('active');
    }

    // Update UI
    this.updateProgress();
    this.updateNavigation();
    this.validateCurrentStep();
    this.updateStepClass();

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  updateProgress() {
    const progressBar = document.getElementById('quiz-progress-bar');
    if (progressBar) {
      // Don't count email capture in progress (step 5)
      const effectiveStep = this.currentStep > 5 ? 5 : this.currentStep;
      const progress = (effectiveStep / 5) * 100;
      progressBar.style.width = `${progress}%`;
    }
  }

  updateStepClass() {
    const mainWrapper = document.querySelector('.main-quiz-wrapper');
    if (mainWrapper) {
      // Remove all step classes
      mainWrapper.classList.remove('step-1', 'step-2', 'step-3', 'step-4', 'step-5', 'step-6', 'step-results');

      // Add current step class
      if (this.currentStep === 6) {
        mainWrapper.classList.add('step-results');
      } else {
        mainWrapper.classList.add(`step-${this.currentStep}`);
      }
    }
  }

  updateNavigation() {
    const backBtn = document.getElementById('quiz-back-btn');
    const nextBtn = document.getElementById('quiz-next-btn');

    // Show/hide back button
    if (backBtn) {
      backBtn.style.display = this.currentStep > 1 && this.currentStep <= 6 ? 'block' : 'none';
    }

    // Hide next button for steps 1-4 (auto-advance on selection)
    // Keep hidden for step 5 (email) and step 6 (results)
    if (nextBtn) {
      nextBtn.style.display = 'none';
    }
  }



  handleEmailSubmit() {
    // --- Email validation ---
    const emailInput = document.getElementById('quiz-email');
    const emailError = document.getElementById('email-error');

    if (!emailInput) return;

    const email = emailInput.value.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email || !emailRegex.test(email)) {
      if (emailError) {
        emailError.textContent = 'Please enter a valid email address';
        emailError.style.display = 'block';
      }
      return; // Stop here if email is invalid
    }

    // Clear previous email error state
    if (emailError) {
      emailError.textContent = '';
      emailError.style.display = 'none';
    }

    // Persist email in responses
    this.responses['email'] = email;

    // --- WA/NV checkbox state ---
    const stateCheckbox = document.getElementById('quiz-state-checkbox');
    const isWaNvChecked = !!(stateCheckbox && stateCheckbox.checked);
    this.responses['state-resident'] = isWaNvChecked;

    // --- NV validation: first two required when WA/NV is checked ---
    const nvError = document.getElementById('nv-error');
    const nvInputs = document.querySelectorAll('.nv-required'); // Must match your HTML class

    if (isWaNvChecked) {
      // Filter only the NV inputs marked as required via data attribute
      const requiredNv = Array.from(nvInputs).filter(i => i.dataset.requiredWhenChecked === 'true');
      const allRequiredChecked = requiredNv.every(i => i.checked);

      if (!allRequiredChecked) {
        // Show error and focus the first missing required checkbox
        if (nvError) {
          nvError.textContent = 'Please check the first two required options to proceed.';
          nvError.style.display = 'block';
        }
        const firstMissing = requiredNv.find(i => !i.checked);
        if (firstMissing) firstMissing.focus();

        return; // Block submission if invalid
      } else {
        // Clear NV error when valid
        if (nvError) {
          nvError.textContent = '';
          nvError.style.display = 'none';
        }
      }
    } else {
      // If WA/NV is not checked, clear NV error (if any)
      if (nvError) {
        nvError.textContent = '';
        nvError.style.display = 'none';
      }
    }

    // Optional: record NV consents for analytics/debug
    this.responses['nv_opt_1'] = document.getElementById('nv-opt-1')?.checked || false;
    this.responses['nv_opt_2'] = document.getElementById('nv-opt-2')?.checked || false;
    this.responses['nv_opt_3'] = document.getElementById('nv-opt-3')?.checked || false;

    // --- Shadow Root & Submission ---
    const formEmbed = document.querySelector('div #app-embed');
    if (!formEmbed || !formEmbed.shadowRoot) {
      console.warn('Form embed or shadowRoot is not available.');
      return;
    }

    const shadowEmail = formEmbed.shadowRoot.querySelector('#email');
    const emailInputValue = document.querySelector('.quiz-form input#quiz-email');

    if (!shadowEmail || !emailInputValue) {
      console.warn('Email field inside shadowRoot or visible email input not found.');
      return;
    }

    // Sync email into the embedded form
    shadowEmail.value = emailInputValue.value;

    // Shadow form fields (guarded)
    const skinType = formEmbed.shadowRoot.querySelector('#custom\\#skin-type');
    const skincareGoals = formEmbed.shadowRoot.querySelector('#custom\\#skincare-goals');
    const ageGroup = formEmbed.shadowRoot.querySelector('#custom\\#age-group');
    const skincareRegimen = formEmbed.shadowRoot.querySelector('#custom\\#skincare-regimen');

    // NV/WA residency & CHD consents (radio inputs assumed)
    const nvwaResidencyTrue = formEmbed.shadowRoot.querySelector('#custom\\#nvwa_residency-true');
    const chdCollectionTrue = formEmbed.shadowRoot.querySelector('#custom\\#consumer_health_data_collection_consent-true');
    const chdSharingTrue = formEmbed.shadowRoot.querySelector('#custom\\#consumer_health_data_sharing_consent-true');
    const chdMediaTrue = formEmbed.shadowRoot.querySelector('#custom\\#consumer_health_data_media_consent-true');

    // When WA/NV is checked, propagate NV consents to shadow form radios
    if (isWaNvChecked) {
      // Residency: set "true"
      if (nvwaResidencyTrue) {
        // If it's a radio, mark it checked
        nvwaResidencyTrue.checked = true;
        nvwaResidencyTrue.dispatchEvent(new Event('change', { bubbles: true }));
        nvwaResidencyTrue.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Consent #1 (required): collection
      const nvOpt1Checked = !!document.getElementById('nv-opt-1')?.checked;
      if (chdCollectionTrue && nvOpt1Checked) {
        chdCollectionTrue.checked = true;
        chdCollectionTrue.dispatchEvent(new Event('change', { bubbles: true }));
        chdCollectionTrue.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Consent #2 (required): sharing
      const nvOpt2Checked = !!document.getElementById('nv-opt-2')?.checked;
      if (chdSharingTrue && nvOpt2Checked) {
        chdSharingTrue.checked = true;
        chdSharingTrue.dispatchEvent(new Event('change', { bubbles: true }));
        chdSharingTrue.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Consent #3 (optional): media/ads
      const nvOpt3Checked = !!document.getElementById('nv-opt-3')?.checked;
      if (chdMediaTrue && nvOpt3Checked) {
        chdMediaTrue.checked = true;
        chdMediaTrue.dispatchEvent(new Event('change', { bubbles: true }));
        chdMediaTrue.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    // Trigger change-like events in shadow form fields (guarded)
    ['input', 'change', 'keyup'].forEach(evt => {
      shadowEmail.dispatchEvent(new Event(evt, { bubbles: true }));
      if (skinType) skinType.dispatchEvent(new Event(evt, { bubbles: true }));
      if (skincareGoals) skincareGoals.dispatchEvent(new Event(evt, { bubbles: true }));
      if (ageGroup) ageGroup.dispatchEvent(new Event(evt, { bubbles: true }));
      if (skincareRegimen) skincareRegimen.dispatchEvent(new Event(evt, { bubbles: true }));
    });

    // Submit embedded form and show results
    setTimeout(() => {
      const submitBtn = formEmbed.shadowRoot.querySelector('button[type="submit"]');
      if (submitBtn) submitBtn.click();
      this.showResults(true);
    }, 1000);
  }


  skipEmailCapture() {
    // Show results without discount
    this.showResults(false);
  }

  showResults(hasDiscount = false) {
    // Hide step 5, show results
    const step5 = document.getElementById('step-5');
    const stepResults = document.getElementById('step-results');

    if (step5) step5.classList.remove('active');
    if (stepResults) stepResults.classList.add('active');

    this.currentStep = 6;
    this.updateProgress();
    this.updateNavigation();
    this.updateStepClass();

    // Show discount banner if applicable
    if (hasDiscount) {
      const discountBanner = document.getElementById('quiz-discount-banner');
      const discountCodeDisplay = document.getElementById('discount-code-display');
      const discountAmount = document.getElementById('discount-amount');

      if (discountBanner) discountBanner.style.display = 'block';
      if (discountCodeDisplay) discountCodeDisplay.textContent = this.discountCode;
      if (discountAmount) discountAmount.textContent = `${this.discountPercentage}%`;
    }

    // Calculate and display recommendations
    this.calculateRecommendations();
  }

  calculateRecommendations() {
    debugger
    const loading = document.getElementById('quiz-results-loading');
    const resultsGrid = document.getElementById('quiz-results-grid');
    const emptyState = document.getElementById('quiz-results-empty');

    // Show loading
    if (loading) loading.style.display = 'block';
    if (resultsGrid) resultsGrid.style.display = 'none';
    if (emptyState) emptyState.style.display = 'none';

    // Simulate loading delay
    setTimeout(() => {
      /* Get recommended products using quiz-logic.js
      if (typeof QuizLogic !== 'undefined') {
        this.selectedProducts = QuizLogic.getRecommendedProducts(this.results, this.responses);
      } else {
        // Fallback if logic not loaded
        this.selectedProducts = this.results.slice(0, 5);
      }
      */
      let skincareRegimenInput = document.querySelector('.quiz-option input[name="regimen-preference"]:checked').value;
      let skincareGoalInput = document.querySelector('.quiz-option input[name="skincare-goals"]:checked').dataset.optionIndex;
      let optionReference = this.results.find(op =>
        op.option_regimen.toLowerCase() == skincareRegimenInput.toLowerCase() && op.option_ref.toLowerCase() == skincareGoalInput.toLowerCase()
      )
      this.selectedProducts = optionReference.products.filter(Boolean)

      // Filter out products with $0 price or out of stock (same as PDP/PLP)
      // this.selectedProducts = this.filterAvailableProducts(this.selectedProducts);

      // Hide loading
      if (loading) loading.style.display = 'none';

      // Display results or empty state
      if (this.selectedProducts.length > 0) {
        this.displayProducts();
        if (resultsGrid) resultsGrid.style.display = 'flex';
      } else {
        if (emptyState) emptyState.style.display = 'block';
      }
    }, 1500);
  }

  filterAvailableProducts(products) {
    // Filter products that are available and have price > $0
    // Same logic as PDP/PLP - don't show free products or out of stock items
    return products.filter((product) => {
      // Check if product is available
      if (!product.available) {
        return false;
      }

      // Get first available variant
      const availableVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0];

      if (!availableVariant) {
        return false;
      }

      // Check if variant is available
      if (!availableVariant.available) {
        return false;
      }

      // Check if price is greater than $0 (price is in cents)
      if (!availableVariant.price || availableVariant.price <= 0) {
        return false;
      }

      return true;
    });
  }

  /* NO LONGER USED
  updateRegimenStepCounts() {
    return
    // Count available products for each regimen
    const basicCount = this.filterAvailableProducts(this.results_basic || []).length;
    const completeCount = this.filterAvailableProducts(this.results_complete || []).length;
    const ultimateCount = this.filterAvailableProducts(this.results_ultimate || []).length;

    // Update product count text for each option
    const basicOption = document.querySelector('input[name="regimen-preference"][value="basic"]')?.closest('.quiz-option');
    const completeOption = document.querySelector('input[name="regimen-preference"][value="complete"]')?.closest('.quiz-option');
    const ultimateOption = document.querySelector('input[name="regimen-preference"][value="ultimate"]')?.closest('.quiz-option');

    if (basicOption) {
      const countElement = basicOption.querySelector('.product-count');
      if (countElement) {
        countElement.textContent = `(${basicCount} product${basicCount !== 1 ? 's' : ''})`;
      }
      // Hide option if count is 0
      if (basicCount === 0) {
        basicOption.style.display = 'none';
      }
    }

    if (completeOption) {
      const countElement = completeOption.querySelector('.product-count');
      if (countElement) {
        countElement.textContent = `(${completeCount} product${completeCount !== 1 ? 's' : ''})`;
      }
      // Hide option if count is 0
      if (completeCount === 0) {
        completeOption.style.display = 'none';
      }
    }

    if (ultimateOption) {
      const countElement = ultimateOption.querySelector('.product-count');
      if (countElement) {
        countElement.textContent = `(${ultimateCount} product${ultimateCount !== 1 ? 's' : ''})`;
      }
      // Hide option if count is 0
      if (ultimateCount === 0) {
        ultimateOption.style.display = 'none';
      }
    }
  }
  */

  displayProducts() {
    const resultsGrid = document.getElementById('quiz-results-grid');
    if (!resultsGrid) return;

    resultsGrid.innerHTML = '';

    this.selectedProducts.forEach((product) => {
      const productCard = this.createProductCard(product);
      resultsGrid.appendChild(productCard);
    });

    // Setup add to cart buttons
    this.setupAddToCartButtons();

  }

  createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'quiz-product-card';
    card.setAttribute('data-product-id', product.id);

    // Get first available variant (same logic as filter)
    const availableVariant = product.variants?.find((variant) => variant.available) || product.variants?.[0];
    const variant = availableVariant || {};
    const price = variant.price ? (variant.price / 100).toFixed(2) : '0.00';
    const comparePrice = variant.compare_at_price ? (variant.compare_at_price / 100).toFixed(2) : null;

    // Category from metafield
    const category = product.category;

    card.setAttribute('data-available-variant', variant.available);

    card.innerHTML = `
    <div class="quiz-product-category">${category}</div>
    <div class="quiz-product-category-wrapper">
        <div class="quiz-product-image">
        
        <div class="quiz-product-badges">
          ${product.tags?.includes('new') ? '<span class="quiz-badge quiz-badge-new">✨ New ✨</span>' : ''}
        </div>
          <img src="${product.featured_image || product.images?.[0]?.src || ''}" 
              alt="${product.title}" 
              loading="lazy">
        </div>
        <div class="quiz-card__content">
          <div class="quiz-card__information">
            <div class="quiz-product-title-description">
              <h3 class="quiz-product-title">${product.title}</h3>
              <p class="quiz-product-description">${this.truncateText(product.description || '', 50)}</p>
            </div>
            <div data-bv-show="inline_rating" data-bv-product-id="${product.id}"></div>
          
            <div class="quiz-product-price">
              <span class="price-current">$${price}</span>
              ${comparePrice ? `<span class="price-original">$${comparePrice}</span>` : ''}
            </div>
          </div>
          <button
            class="quiz-product-add-btn button button--secondary"
            data-variant-id="${variant.id}" 
            ${variant.available ? '' : 'disabled'}
          >
            ${variant.available ? 'ADD TO BAG' : 'Sold Out'}
          </button>
        </div>
      </div>
    `;

    return card;
  }

  getProductCategory(product) {
    // Debug: Log entire product object to see structure
    console.log('=== Product Category Debug ===');
    console.log('Product:', product);
    console.log('Product title:', product.title);
    console.log('Product ID:', product.id);

    // Check for metafields in various possible structures
    console.log('product.metafields:', product.metafields);
    console.log('product.metafields?.quiz:', product.metafields?.quiz);
    console.log('product.metafields?.quiz?.product_category:', product.metafields?.quiz?.product_category);

    // Try alternative metafield paths
    if (product.metafields) {
      console.log('All metafields keys:', Object.keys(product.metafields));

      // Check if metafields is an array
      if (Array.isArray(product.metafields)) {
        console.log('Metafields is an array:', product.metafields);
        const categoryMetafield = product.metafields.find(m =>
          m.namespace === 'quiz' && m.key === 'product_category'
        );
        if (categoryMetafield && categoryMetafield.value) {
          let categoryValue = categoryMetafield.value;
          console.log('Found category metafield in array:', categoryValue, 'Type:', typeof categoryValue, 'Is Array:', Array.isArray(categoryValue));

          // Handle nested value if it's an object (but not an array)
          if (typeof categoryValue === 'object' && categoryValue !== null && !Array.isArray(categoryValue) && categoryValue.value !== undefined) {
            categoryValue = categoryValue.value;
            console.log('Extracted nested value:', categoryValue);
          }

          // Handle array - take first element
          if (Array.isArray(categoryValue) && categoryValue.length > 0) {
            categoryValue = categoryValue[0];
            console.log('Extracted first element from array:', categoryValue);
          }

          // Only format if it's a valid string value
          if (categoryValue != null && categoryValue !== '' && (typeof categoryValue === 'string' || typeof categoryValue === 'number')) {
            return this.formatCategory(String(categoryValue));
          }
        }
      }

      // Check if metafields is an object with nested structure
      if (product.metafields.quiz?.product_category) {
        let categoryValue = product.metafields.quiz.product_category;
        console.log('Product metafield category (quiz.product_category):', categoryValue, 'Type:', typeof categoryValue, 'Is Array:', Array.isArray(categoryValue), 'for product:', product.title);

        // Handle metafield that might be an object with .value property
        if (typeof categoryValue === 'object' && categoryValue !== null && !Array.isArray(categoryValue) && categoryValue.value !== undefined) {
          categoryValue = categoryValue.value;
          console.log('Extracted value from metafield object:', categoryValue);
        }

        // Handle array - take first element
        if (Array.isArray(categoryValue) && categoryValue.length > 0) {
          categoryValue = categoryValue[0];
          console.log('Extracted first element from array:', categoryValue);
        }

        // Only format if it's a valid string value
        if (categoryValue != null && categoryValue !== '' && (typeof categoryValue === 'string' || typeof categoryValue === 'number')) {
          return this.formatCategory(String(categoryValue));
        }
      }

      // Check for direct metafield access
      if (product.metafields.product_category) {
        let categoryValue = product.metafields.product_category;
        console.log('Product metafield category (direct):', categoryValue, 'Type:', typeof categoryValue, 'Is Array:', Array.isArray(categoryValue), 'for product:', product.title);

        // Handle metafield that might be an object with .value property
        if (typeof categoryValue === 'object' && categoryValue !== null && !Array.isArray(categoryValue) && categoryValue.value !== undefined) {
          categoryValue = categoryValue.value;
          console.log('Extracted value from metafield object:', categoryValue);
        }

        // Handle array - take first element
        if (Array.isArray(categoryValue) && categoryValue.length > 0) {
          categoryValue = categoryValue[0];
          console.log('Extracted first element from array:', categoryValue);
        }

        // Only format if it's a valid string value
        if (categoryValue != null && categoryValue !== '' && (typeof categoryValue === 'string' || typeof categoryValue === 'number')) {
          return this.formatCategory(String(categoryValue));
        }
      }
    }

    // Fallback to tags - check all tags before returning default
    console.log('Product tags:', product.tags);
    const categoryTags = ['cleanser', 'serum', 'am_moisturizer', 'pm_moisturizer', 'moisturizer', 'eye', 'treatment'];
    for (const tag of categoryTags) {
      if (product.tags?.includes(tag)) {
        console.log('Product category from tag:', tag, 'for product:', product.title);
        return this.formatCategory(tag);
      }
    }

    // Default fallback if no category found
    console.log('Product category: Skincare (default) for product:', product.title);
    console.log('=== End Product Category Debug ===');
    return 'Skincare';
  }

  formatCategory(category) {
    // Ensure category is a string
    if (!category) {
      return 'Skincare';
    }

    // Convert to string if it's not already
    const categoryStr = String(category);

    // If it's an empty string, return default
    if (!categoryStr.trim()) {
      return 'Skincare';
    }

    return categoryStr
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  truncateText(text, maxLength) {
    const div = document.createElement('div');
    div.innerHTML = text;
    const plainText = div.textContent || div.innerText || '';

    if (plainText.length <= maxLength) return plainText;
    return plainText.substr(0, maxLength) + '...';
  }

  setupAddToCartButtons() {
    // Individual add to cart buttons
    const addBtns = document.querySelectorAll('.quiz-product-add-btn');
    addBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const variantId = e.target.getAttribute('data-variant-id');
        if (variantId) {
          this.addToCart(variantId);
        }
      });
    });

    // Add all to cart button
    const addAllBtn = document.getElementById('quiz-add-all-to-cart');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', () => this.addAllToCart());
    }
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url)
        ? routes.cart_add_url
        : (this.cartAddUrl || '/cart/add.js');

      if (!cartDrawer) {
        console.warn('Cart drawer not found');
        // Fallback: simple add without updating drawer
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: quantity }],
          }),
        });
        if (response.ok) {
          alert('Product added to cart!');
        }
        return;
      }

      // Get sections to render (same format as cart-drawer-recommended-products.js)
      const sectionsToRender = [
        {
          section_id: 'cart-drawer',
        },
        {
          section_id: 'cart-icon-bubble',
        },
      ];

      const body = JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: quantity }],
        sections: sectionsToRender.map((section) => section.section_id),
      });

      const response = await fetch(cartAddUrl, { ...fetchConfig(), ...{ body } });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Check for errors in response
      if (data.status || data.errors) {
        throw new Error(data.description || data.message || 'Failed to add to cart');
      }

      // Use updateLiveContent pattern (more reliable than renderContents for JSON requests)
      // This updates specific elements instead of replacing the entire drawer
      if (data.items && data.items.length > 0) {
        cartDrawer.classList.remove('is-empty');
      }

      if (data.sections) {
        await this.updateLiveContent(data.sections);

        // Open cart drawer after updating (like section-byob.js does)
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon && typeof cartIcon.click === 'function') {
          cartIcon.click();
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } else {
        console.warn('No sections in response:', data);
      }

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Error adding product to cart. Please try again.');
    }
  }

  async fetchAndUpdateCartDrawer() {
    // Fetch cart drawer sections separately if not included in add response
    try {
      const cartUrl = (typeof routes !== 'undefined' && routes.cart_url)
        ? routes.cart_url
        : '/cart';

      const response = await fetch(`${cartUrl}?section_id=cart-drawer`);
      if (!response.ok) {
        console.warn('Failed to fetch cart drawer section');
        return;
      }

      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');

      // Update cart drawer items
      const sourceCartItems = html.querySelector('cart-drawer-items');
      const targetCartItems = document.querySelector('cart-drawer-items');
      if (sourceCartItems && targetCartItems) {
        targetCartItems.replaceWith(sourceCartItems);
      }

      // Update drawer header
      const sourceHeader = html.querySelector('.drawer__header');
      const targetHeader = document.querySelector('.drawer__header');
      if (sourceHeader && targetHeader) {
        targetHeader.replaceWith(sourceHeader);
      }

      // Update drawer footer
      const sourceFooter = html.querySelector('.drawer__footer');
      const targetFooter = document.querySelector('.drawer__footer');
      if (sourceFooter && targetFooter) {
        targetFooter.replaceWith(sourceFooter);
      }

      // Update cart icon bubble - use cart-icon-bubble section (like section-byob.js)
      const cartIconResponse = await fetch(`${cartUrl}?section_id=cart-icon-bubble`);
      if (cartIconResponse.ok) {
        const cartIconHtmlText = await cartIconResponse.text();
        const cartIconHtml = new DOMParser().parseFromString(cartIconHtmlText, 'text/html');
        const sourceSection = cartIconHtml.querySelector('.shopify-section');
        const targetCartIcon = document.querySelector('#cart-icon-bubble');

        if (sourceSection && targetCartIcon) {
          // Update innerHTML of #cart-icon-bubble with .shopify-section content
          targetCartIcon.innerHTML = sourceSection.innerHTML;
        }
      }
    } catch (error) {
      console.error('Error fetching cart drawer sections:', error);
    }
  }

  async updateLiveContent(updatedSections) {
    // Same pattern as cart-drawer-recommended-products.js
    const sectionsToRender = [
      {
        section_id: 'cart-drawer',
        selectors: ['.drawer__header', 'cart-drawer-items', '.drawer__footer'],
      },
      {
        section_id: 'cart-icon-bubble',
        selectors: [{ target: '#cart-icon-bubble', source: '.shopify-section', action: 'innerHTML' }],
      },
    ];

    try {
      for (const section of sectionsToRender) {
        const content = updatedSections[section.section_id];
        if (!content) {
          console.warn(`No content for section: ${section.section_id}`);
          continue;
        }

        // Parse HTML - it may be wrapped in .shopify-section
        const html = new DOMParser().parseFromString(content, 'text/html');

        // Try to find .shopify-section wrapper first
        let rootElement = html.querySelector('.shopify-section');
        if (!rootElement) {
          rootElement = html.documentElement || html.body || html;
        }

        section.selectors.forEach((selector) => {
          // Handle object-based selectors (like cart-icon-bubble)
          if (typeof selector === 'object' && selector.target && selector.source) {
            const targetElement = document.querySelector(selector.target);
            const sourceElement = html.querySelector(selector.source);
            if (targetElement && sourceElement) {
              if (selector.action === 'innerHTML') {
                targetElement.innerHTML = sourceElement.innerHTML;
              } else {
                targetElement.replaceWith(sourceElement);
              }
            }
            return;
          }

          // Handle string-based selectors (standard)
          const targetElement = document.querySelector(selector);
          if (!targetElement) {
            console.warn(`Target element not found: ${selector}`);
            return;
          }

          // Search in the root element (may be inside .shopify-section)
          const sourceElement = rootElement.querySelector(selector);

          if (!sourceElement) {
            console.warn(`Source element not found in HTML: ${selector}`);
            // Try searching in the entire document
            const altSource = html.querySelector(selector);
            if (altSource) {
              if (altSource.classList.contains('is-empty')) {
                altSource.classList.remove('is-empty');
              }
              targetElement.replaceWith(altSource.cloneNode(true));
              return;
            }
            return;
          }

          if (sourceElement.classList.contains('is-empty')) {
            sourceElement.classList.remove('is-empty');
          }

          targetElement.replaceWith(sourceElement.cloneNode(true));
        });
      }
    } catch (error) {
      console.error('Error updating live content:', error);
    }
  }

  async addAllToCart() {
    const items = this.selectedProducts
      .filter((p) => p.variants && p.variants.length > 0 && p.variants[0].available)
      .map((p) => ({
        id: parseInt(p.variants[0].id),
        quantity: 1,
      }));

    if (items.length === 0) return;

    // Declare variables outside try block so they're available in catch
    const cartDrawer = document.querySelector('cart-drawer');
    const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url)
      ? routes.cart_add_url
      : (this.cartAddUrl || '/cart/add.js');

    // Get sections to render (same format as cart-drawer-recommended-products.js)
    const sectionsToRender = [
      {
        section_id: 'cart-drawer',
      },
      {
        section_id: 'cart-icon-bubble',
      },
    ];

    try {

      const body = JSON.stringify({
        items: items,
        sections: sectionsToRender.map((section) => section.section_id),
      });

      const response = await fetch(cartAddUrl, { ...fetchConfig(), ...{ body } });
      const data = await response.json();

      // Check for errors in response
      if (!response.ok || data.status || data.errors) {
        console.warn('Bulk add failed, trying one by one:', data.description || data.message || 'HTTP ' + response.status);
        throw new Error('Bulk add failed');
      }

      // Update cart drawer (same as cart-drawer-recommended-products.js)
      if (data.items && data.items.length > 0 && cartDrawer) {
        cartDrawer.classList.remove('is-empty');
      }

      // Use updateLiveContent pattern
      if (data.sections) {
        await this.updateLiveContent(data.sections);
      } else {
        // If sections not in response, fetch them separately
        await this.fetchAndUpdateCartDrawer();
      }

      // Open cart drawer after updating
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon && cartIcon.click) {
        cartIcon.click();
      } else if (cartDrawer && cartDrawer.open) {
        cartDrawer.open();
      }
    } catch (error) {
      // Fallback: Add items one by one if bulk add fails
      try {
        let lastResponse = null;
        let successCount = 0;

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const body = JSON.stringify({
            items: [item],
            // Only request sections on the last item to get final cart state
            sections: i === items.length - 1 ? sectionsToRender.map((section) => section.section_id) : [],
          });

          const response = await fetch(cartAddUrl, { ...fetchConfig(), ...{ body } });
          const data = await response.json();

          if (!response.ok || data.status || data.errors) {
            console.error(`Failed to add item ${i + 1} (${item.id}):`, data.description || data.message);
            continue; // Skip this item and continue with next
          }

          successCount++;
          lastResponse = data;

          // Small delay between requests to avoid rate limiting
          if (i < items.length - 1) {
            await new Promise(resolve => setTimeout(resolve, 200));
          }
        }

        if (successCount === 0) {
          throw new Error('Failed to add any items to cart');
        }

        // Update cart drawer with last response (which should have all items)
        if (lastResponse) {
          if (lastResponse.items && lastResponse.items.length > 0 && cartDrawer) {
            cartDrawer.classList.remove('is-empty');
          }

          if (lastResponse.sections) {
            await this.updateLiveContent(lastResponse.sections);
          } else {
            // If sections not in response, fetch them separately
            await this.fetchAndUpdateCartDrawer();
          }

          // Open cart drawer after updating
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon && typeof cartIcon.click === 'function') {
            cartIcon.click();
          } else if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }

        // Show success message
        if (successCount < items.length) {
          alert(`Added ${successCount} of ${items.length} products to cart.`);
        }

      } catch (fallbackError) {
        console.error('Error adding all to cart (fallback also failed):', fallbackError);
        alert('Error adding products to cart. Please try again.');
      }
    }
  }

  handleExit() {
    const confirmed = confirm('Are you sure you want to exit the quiz? Your progress will be lost.');
    if (confirmed) {
      // Redirect to homepage or collection page
      window.location.href = '/';
    }
  }

  restartQuiz() {
    // Reset all data
    this.currentStep = 1;
    this.responses = {};
    this.selectedProducts = [];

    document.querySelector('div.quiz-steps-wrapper').style.removeProperty('max-width');

    // Reset UI
    document.querySelectorAll('.quiz-step').forEach((step) => {
      step.classList.remove('active');
    });
    document.getElementById('step-1')?.classList.add('active');

    // Clear all inputs
    document.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((input) => {
      input.checked = false;
    });

    const emailInput = document.getElementById('quiz-email');
    if (emailInput) emailInput.value = '';

    // Update UI
    this.updateProgress();
    this.updateNavigation();
    this.validateCurrentStep();
    this.updateStepClass();

    // Scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

// Initialize quiz when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  window.neostrataQuiz = new ExuvianceQuiz();
});
